/* unplugin-vue-components disabled */import { render } from "./UserDetails.vue?vue&type=template&id=5d4bd5c5&scoped=true&ts=true"
import script from "./UserDetails.vue?vue&type=script&lang=ts"
export * from "./UserDetails.vue?vue&type=script&lang=ts"

import "./UserDetails.vue?vue&type=style&index=0&id=5d4bd5c5&scoped=true&lang=scss"
import "./UserDetails.vue?vue&type=style&index=1&id=5d4bd5c5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4bd5c5"]])

export default __exports__